module.exports = __webpack_public_path__ + "img/girlyellow.c37427d.png";